import options from './tabs.component';

export default {
    selector: 'dtTabs',
    options
};



// WEBPACK FOOTER //
// ./app/common/navbar/tabs/index.js